import React from 'react';

import {GraphEntityStatus, RelationPresentation} from '../../interface';
import {edgePropsByType} from '../../graph-rendering/constants';

interface Props {
    edgePropsByStatus: (typeof edgePropsByType)[RelationPresentation.ASSERTED];
    isDashed?: boolean;
}

const size = 15;

export function LegendEdgeExample(props: Props) {
    const {color} = props.edgePropsByStatus[GraphEntityStatus.default];

    return (
        <svg width={size} height={size}>
            <polyline
                stroke={color}
                points="15,0 0,15"
                strokeWidth={2}
                strokeDasharray={props.isDashed ? '4 4' : undefined}
            />
        </svg>
    );
}
